// @ts-nocheck
import React from 'react';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import KwPanel from '../../../common/KwPanel';

import { deleteKeyProviderPlatform } from '../../../../actions/keyProviderActions';
import { toast } from 'react-toastify';
import Button from '../../../common/Button';
import ConfirmationHeader from '../../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';

function DeleteKeyProviderPlatform({
  done,
  keyProviderId,
  platformId,
  cancel,
}) {
  const { t } = useTranslation();
  const handleDelete = () => {
    deleteKeyProviderPlatform(keyProviderId, platformId)
      .then(() => {
        toast.success(t('Platform successfully deleted from key provider'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to delete platform from key provider'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the platform on this key provider')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}


export default DeleteKeyProviderPlatform;
